import { GotoError, HandleErrorsGlobalRecord, PlannedError } from '@platform-frontend/util';

export const PLATFORM_STARTUP_ERROR_HANDLERS = (error: any): HandleErrorsGlobalRecord => {
  const errorType = error instanceof PlannedError ? error.errorType : undefined;
  return { DEFAULT: new GotoError({ clearNotifications: false, queryParams: { errorType } }) };
};
